import { useIsUngatedForUserLevelCapacityLimits, useIsUngatedForUserLevelCapacityLimitsTicketType } from '../../auth/hooks/useGates';
import { getAgentMessageTypes } from '../utils/agent-status-messages';
import { AgentAvailabilityStatusMessage } from './AgentAvailabilityStatusMessage';
import { AgentCapacityStatusMessage } from './AgentCapacityStatusMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AgentStatusMessage = ({
  capacityCategory,
  responder
}) => {
  const isUngatedForUserLevelCapacityLimits = useIsUngatedForUserLevelCapacityLimits();
  const isUngatedForCapacityTicketType = useIsUngatedForUserLevelCapacityLimitsTicketType();
  const showCapacityStatus = isUngatedForUserLevelCapacityLimits && (!isUngatedForCapacityTicketType || capacityCategory !== undefined);
  const agentMessageTypes = getAgentMessageTypes(responder, showCapacityStatus, isUngatedForCapacityTicketType, capacityCategory);
  if (agentMessageTypes.availability && agentMessageTypes.capacity) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AgentAvailabilityStatusMessage, {
        agent: responder.agent,
        messageType: agentMessageTypes.availability
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(AgentCapacityStatusMessage, {
        messageType: agentMessageTypes.capacity
      })]
    });
  }
  if (agentMessageTypes.availability) {
    return /*#__PURE__*/_jsx(AgentAvailabilityStatusMessage, {
      agent: responder.agent,
      messageType: agentMessageTypes.availability
    });
  }
  if (agentMessageTypes.capacity) {
    return /*#__PURE__*/_jsx(AgentCapacityStatusMessage, {
      messageType: agentMessageTypes.capacity
    });
  }
  return null;
};
AgentStatusMessage.displayName = 'AgentStatusMessage';
export default AgentStatusMessage;